/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/11
 * Time: 10:11
 * Desc: 网点试穿报表
 */

import { Component, Vue } from 'vue-property-decorator';
import VeLine from 'v-charts/lib/line.common';
import moment from 'moment';
import { IPSService } from '@/services/ipsServices';
import NoAuth from '@/views/components/noAuth/noAuth.vue';

@Component({
  components: {
    VeLine,
    NoAuth,
  },
})
export default class SiteTryOn extends Vue {
  /* 数据 */

  /**
   * 网点名称
   * @type {Array<ItemObject>}
   */
  public siteName = '';

  /**
   * loading状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * 试穿列表
   * @type {Array<ItemObject>}
   */
  public tryOnList = [];

  /**
   * 图表配置
   * @type {Array<string>}
   */
  public chartOptions: ItemObject = {
    colors: ['#3e6ef7'],
    series: [
      {
        data: [],
        type: 'line',
        smooth: false,
      },
    ],
    xAxis: {
      type: 'category',
      data: [],
    },
    yAxis: {
      type: 'value',
    },
    tooltip: {
      trigger: 'item',
      formatter(params) {
        return `总申请人数 :</br>${params.name}&nbsp;&nbsp;&nbsp;${params.value}人`;
      },
    },
  };

  /**
   * 试穿时间类型
   * @type {string}
   */
  public tryOnDateType = 'today';

  /**
   * 试穿开始时间
   * @type {string}
   */
  public tryOnBeginDay = '';

  /**
   * 试穿结束时间
   * @type {string}
   */
  public tryOnEndDay = '';

  /**
   * 总数
   * @type {number}
   */
  public totalTryOnCount = 0;

  /**
   * 最受欢迎的商品TOP10列表
   * @return null
   */
  public topTenGoodsList: Array<ItemObject> = [];

  /**
   * top10时间类型
   * @type {string}
   */
  public topTenDateType = 'today';

  /**
   * top10开始时间
   * @type {string}
   */
  public topTenBeginDay = '';

  /**
   * top10结束时间
   * @type {string}
   */
  public topTenEndDay = '';

  /**
   * 图标是否显示
   * @type {boolean}
   */
  public isShowChart = false;

  /**
   * 预约人数开始时间选择配置
   * @type {ItemObject}
   */
  public tryOnStartPickerOptions: ItemObject = {
    disabledDate: (time) => {
      // 设置可选择的日期为今天之后的一个月内
      // const curDate = (new Date()).getTime();
      // 这里算出一个月的毫秒数,
      return time.getTime() > Date.now();
    },
  };

  /**
   * 预约人数结束时间选择配置
   * @type {ItemObject}
   */
  public tryOnEndPickerOptions = {
    disabledDate: (time) => {
      return true;
    },
  };

  /**
   * top10开始时间选择配置
   * @type {ItemObject}
   */
  public topTenStartPickerOptions = {
    disabledDate: (time) => {
      // 设置可选择的日期为今天之后的一个月内,
      // 这里算出一个月的毫秒数,
      return time.getTime() > Date.now();
    },
  };

  /**
   * top10结束时间选择配置
   * @type {ItemObject}
   */
  public topTenEndPickerOptions = {
    disabledDate: (time) => {
      return true;
    },
  };

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;

  /* 方法 */

  /**
   * 预约试穿时间类型选择
   * @param {string} type
   * @return null
   */
  public onSelectTryOnDateType(type): void {
    if (type != 'custom') { this.onGetTryOnList(); }
  }

  /**
   * 获取试穿数据
   * @return null
   */
  public onGetTryOnList(): void {
    const queryParams = {
      siteId: Number.parseInt(this.$route.params.id), // 网点ID
      dayType: this.tryOnDateType, // 时间选项(今日-today 昨日-yesterday 7天前-sevenDaysAgo 自定义-custom)
      limitNum: 10,
    };
    if (this.tryOnDateType === 'custom') {
      if (!this.tryOnBeginDay) {
        this.$message.warning('请选择开始时间');
        return;
      } else if (!this.tryOnEndDay) {
        this.$message.warning('请选结束时间');
        return;
      } else {
        queryParams['beginDay'] = moment(this.tryOnBeginDay).format('YYYY-MM-DD');
        queryParams['endDay'] = moment(this.tryOnEndDay).format('YYYY-MM-DD');
      }
    }
    IPSService.siteTryOnNumByTime({ queryParams })
      .then((res) => {
        if (res) {
          this.tryOnBeginDay = res.beginDay;
          this.tryOnEndDay = res.endDay;
          this.totalTryOnCount = res.tryOnAllNum || 0;
          this.chartOptions.series[0].data = res.list.map((item) => {
            return item.tryOnNum;
          });
          this.chartOptions.xAxis.data = res.list.map((item) => {
            return item.tryOnTime;
          });
          this.isShowChart = true;
        }
      })
      .catch((err) => {
        throw err;
      });
  }

  /**
   * 设置试穿结束时间
   * @return null
   */
  public onSetTryOnEndTime(): void {
    this.tryOnEndPickerOptions = {
      disabledDate: (time) => {
        // 设置可选择的日期为今天之后的一个月内
        const curDate = this.tryOnBeginDay.valueOf();
        // 这里算出一个月的毫秒数,
        // 这里使用30的平均值,实际中应根据具体的每个月有多少天计算
        const day = 60 * 24 * 3600 * 1000;
        const dateRegion = curDate + day;
        return time.getTime() > dateRegion || time.getTime() < curDate || time.getTime() > new Date();
      },
    };
  }

  /**
   * Top10时间类型选择
   * @param {string} type
   * @return null
   */
  public onSelectTopTenDayType(type): void {
    if (type != 'custom') { this.onGetTopTenList(); }
  }

  /**
   * 获取Top10列表
   * @return null
   */
  public onGetTopTenList(): void {
    const queryParams = {
      siteId: Number.parseInt(this.$route.params.id), // 网点ID
      dayType: this.topTenDateType, // 时间选项(今日-today 昨日-yesterday 7天-lastSevenDay  lastThirtyDay 自定义-custom)
      limitNum: 10,
    };
    if (this.topTenDateType === 'custom') {
      if (!this.topTenBeginDay) {
        this.$message.warning('请选择开始时间');
        return;
      } else if (!this.topTenEndDay) {
        this.$message.warning('请选结束时间');
        return;
      } else {
        queryParams['beginDay'] = moment(this.topTenBeginDay).format('YYYY-MM-DD');
        queryParams['endDay'] = moment(this.topTenEndDay).format('YYYY-MM-DD');
      }
    }
    IPSService.siteTryOnTop({ queryParams })
      .then((res) => {
        if (res) {
          this.topTenGoodsList = res.list;
          this.topTenBeginDay = res.beginDay;
          this.topTenEndDay = res.endDay;
        }
      })
      .catch((err) => {
        throw err;
      });
  }

  /**
   * 设置Top10结束时间
   * @return null
   */
  public onSetTopTenEndTime(): void {
    this.topTenEndPickerOptions = {
      disabledDate: (time) => {
        // 设置可选择的日期为今天之后的一个月内
        const curDate = this.topTenBeginDay.valueOf();
        // 这里算出一个月的毫秒数,
        // 这里使用30的平均值,实际中应根据具体的每个月有多少天计算
        const day = 60 * 24 * 3600 * 1000;
        const dateRegion = curDate + day;
        return time.getTime() > dateRegion || time.getTime() < curDate || time.getTime() > new Date();
      },
    };
  }

  /**
   * 获取Top10开始时间焦点
   * @param {number} n
   * @return null
   */
  public beginDayFocus(n: number) {
    n === 1 ? (this.tryOnEndDay = '') : (this.topTenEndDay = '');
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-REPORT-TRYON');
    if (this.isContentBodyShow) {
      this.onGetTryOnList(); // 获取试穿列表
      this.onGetTopTenList(); // 获取Top10列表
    }
  }
}
